export default {"src":"/education/_next/static/media/prepc.3c70445b.svg","height":288,"width":288,"blurWidth":0,"blurHeight":0};